import React from 'react';

import {
  FaFacebookF,
  FaLinkedinIn,
  FaTiktok
} from 'react-icons/fa';

import { company } from '../data/siteData';

/* IMPORT COMPANY LOGO */
import logo from './assets/logo.png';

function Footer() {
  return (
    <footer className="footer">

      <div className="container footer-content">

        {/* LEFT SIDE */}
        <div className="footer-info">
          <h3>{company.name}</h3>

          <p>
            We build software solutions that help businesses innovate,
            automate, and grow with confidence.
          </p>
        </div>

        {/* CENTER LINKS */}
        <div className="footer-links">
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#team">Team</a>
          <a href="#portfolio">Portfolio</a>
          <a href="#contact">Contact</a>
        </div>

        {/* SOCIAL ICONS */}
        <div className="social-icons">

          <a
            href="https://web.facebook.com/people/ZuelonX-It-Solution/61589949248266/"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebookF />
          </a>

          <a
            href="https://www.linkedin.com/company/117674258/admin/inbox/"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedinIn />
          </a>

          <a
            href="https://www.tiktok.com/@zuelonx.it.soluti?lang=en-GB"
            target="_blank"
            rel="noreferrer"
          >
            <FaTiktok />
          </a>

        </div>

        {/* RIGHT SIDE SMALL LOGO */}
        <div className="footer-logo">
          <img src={logo} alt="Company Logo" />
        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>
          © 2026 {company.name}. All rights reserved.
        </p>
      </div>

    </footer>
  );
}

export default Footer;